import { render, staticRenderFns } from "./ResponsibilityEvaluationView.vue?vue&type=template&id=636b0e65&scoped=true"
import script from "./ResponsibilityEvaluationView.vue?vue&type=script&lang=js"
export * from "./ResponsibilityEvaluationView.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityEvaluationView.vue?vue&type=style&index=0&id=636b0e65&prod&lang=css"
import style1 from "./ResponsibilityEvaluationView.vue?vue&type=style&index=1&id=636b0e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b0e65",
  null
  
)

export default component.exports